export { default } from './ConsultingIcon';
